<template>
	<v-dialog :persistent="true" max-width="700" v-model="show">
		<v-card>
			<v-card-text>
				<v-layout row wrap>
					<v-flex md6 xs12>
						<v-layout row wrap>
							<v-flex xs12>
								<InputField :error="personValidation.first_name"
											:label="'* '+$t('fields.firstName')"
											v-model="person.first_name"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField :error="personValidation.last_name"
											:label="'* '+$t('fields.lastName')"
											v-model="person.last_name"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField :error="personValidation.address"
											:label="$t('fields.address')"
											v-model="person.address"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField :error="personValidation.city"
											:label="$t('fields.city')"
											v-model="person.city"></InputField>
							</v-flex>
							<v-flex xs12>
								<Dropdown
									:ajax="true"
									:data="'countries'" :error="personValidation.country_id"
									:label="'* '+$t('fields.country')"
									v-model="person.country_id"></Dropdown>
							</v-flex>
							<v-flex xs12>
								<Dropdown
									:ajax="true"
									:data="'companies'"
									:error="personValidation.company_id"
									:label="$t('fields.company')"
									v-if="showCompany"
									v-model="person.company_id"></Dropdown>
							</v-flex>
							<v-flex xs12>
								<CheckBox
									:label="$t('fields.active')"
									v-model="person.active"></CheckBox>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex md6 xs12>
						<v-layout row wrap>
							<v-flex xs12>
								<InputField :error="personValidation.phone"
											:label="$t('fields.phone')"
											v-model="person.phone"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField :error="personValidation.email"
											:label="$t('fields.email')"
											v-model="person.email"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField :error="personValidation.oib"
											:label="$t('fields.oib')"
											v-model="person.oib"></InputField>
							</v-flex>
							<v-flex xs12>
								<Dropdown
									:ajax="true"
									:readonly="$props.tourgroupid != null"
									:data="'subject-types'"
									:error="personValidation.subject_type_id"
									:label="'* '+$t('fields.type')"
									v-model="person.subject_type_id"></Dropdown>
							</v-flex>
							<v-flex xs12>
								<TextArea
									:error="personValidation.notes"
									:label="$t('fields.notes')"
									v-model="person.notes"/>
							</v-flex>
							<v-flex xs12>
								<UploadMultiple :label="$t('fields.documents')"
												v-model="person.documents"/>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="closeModal">{{ $t('buttons.cancel') }}</v-btn>
				<v-btn v-if="guestCounter === null || guestCounter > 1" @click="saveClick(true)">{{ $t('buttons.saveAndMore') }}</v-btn>
				<v-btn @click="saveClick(false)">{{ $t('buttons.save') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import InputField from "../trinkets/InputField";
import DatePicker from "../trinkets/DatePicker";
import CurrencyField from "../trinkets/CurrencyField";
import Dropdown from "../trinkets/Dropdown";
import TextArea from "../trinkets/TextArea";
import UploadMultiple from "../trinkets/UploadMultiple";
import CheckBox from "../trinkets/CheckBox";

export default {
	name: "PersonModal",
	props: {
		show: {
			default: false
		},
		multiple: {
			default: false
		},
		id: {
			default: 0
		},
		companyid: {
			default: null
		},
		tourgroupid: {
			default: null
		},
		maxGuests: {
			default: null
		}
	},
	components: {
		DatePicker,
		CurrencyField,
		InputField,
		Dropdown,
		TextArea,
		UploadMultiple,
		CheckBox
	},
	data: function () {
		return {
			person: {
				id: this.$props.id,
				first_name: '',
				last_name: '',
				address: '',
				city: '',
				country_id: null,
				phone: '',
				email: '',
				oib: '',
				subject_type_id: null,
				notes: '',
				documents: [],
				active: true,
				date_added: null,
				company_id: this.$props.companyid
			},
			personValidation: {
				id: '',
				first_name: '',
				last_name: '',
				address: '',
				city: '',
				country_id: '',
				phone: '',
				email: '',
				oib: '',
				subject_type_id: '',
				notes: '',
				documents: '',
				active: '',
				date_added: '',
				company_id: ''
			},
			showCompany: true,
			stay: false,
			guestCounter: null
		}
	},
	watch: {
		show: function () {
			this.resetData();
		},
		maxGuests: function () {
			console.log('init1: ' + this.$props.maxGuests);
			this.guestCounter = this.$props.maxGuests;
			console.log('init2: ' + this.guestCounter);
		}
	},
	methods: {
		resetData() {
			this.person = {
				id: 0,
				first_name: '',
				last_name: '',
				address: '',
				city: '',
				country_id: null,
				phone: '',
				email: '',
				oib: '',
				subject_type_id: null,
				notes: '',
				documents: [],
				active: true,
				date_added: null,
				company_id: this.$props.companyid
			};
			this.personValidation = {
				id: '',
				first_name: '',
				last_name: '',
				address: '',
				city: '',
				country_id: '',
				phone: '',
				email: '',
				oib: '',
				subject_type_id: '',
				notes: '',
				documents: '',
				active: '',
				date_added: '',
				company_id: ''
			}
			if (this.$props.companyid != null) {
				this.showCompany = false;
				this.$nextTick(() => {
					this.showCompany = true;
				});
			}
			if (this.$props.tourgroupid != null) {
				this.person.subject_type_id = 1;
			}
		},
		closeModal() {
			this.resetData();
			this.$emit('callback');
		},
		saveClick(more) {
			this.stay = more;
			let success = true;

			if (this.person.first_name == '') {
				success = false;
				this.personValidation.first_name = this.$t('alerts.fieldError');
			} else {
				this.personValidation.first_name = '';
			}
			if (this.person.last_name == '') {
				success = false;
				this.personValidation.last_name = this.$t('alerts.fieldError');
			} else {
				this.personValidation.last_name = '';
			}
			if (this.person.country_id == null) {
				success = false;
				this.personValidation.country_id = this.$t('alerts.fieldError');
			} else {
				this.personValidation.country_id = '';
			}
			if (this.person.subject_type_id == null) {
				success = false;
				this.personValidation.subject_type_id = this.$t('alerts.fieldError');
			} else {
				this.personValidation.subject_type_id = '';
			}
			if ((this.person.oib != '') && (this.person.country_id == 53)) {
				if (!(this.$checkOIB(this.person.oib))) {
					success = false;
					this.personValidation.oib = this.$t('alerts.oibError');
				} else {
					this.personValidation.oib = '';
				}
			} else {
				this.personValidation.oib = '';
			}

			if (success) {
				this.saveAction(() => {
					if (this.stay) {
						this.resetData();
					} else {
						this.$emit('callback');
					}
				});
			}
		},
		saveAction(after = () => {
		}) {
			let vm = this;
			let action = 'post';
			let addition = '';
			if (vm.person.id != 0) {
				action = 'put';
				addition = '/' + vm.person.id;
			}
			let payload = JSON.parse(JSON.stringify(vm.person));
			if (this.$props.tourgroupid != null) {
				payload.tour_group_id = this.$props.tourgroupid;
			}
			vm.$APICall(action, 'people' + addition, payload, (data, success) => {
				if (success) {
					if (vm.guestCounter !== null) {
						vm.guestCounter--;
						console.log('decrease1: ' + vm.guestCounter);
					}
					if (vm.person.id == 0) {
						vm.$notify(vm.$t('alerts.basicAdd'));
					} else {
						vm.$notify(vm.$t('alerts.basicUpdate'));
					}
					vm.$triggerReload();
					after();
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		}
	},
	mounted() {

	}
}
</script>

<style scoped>

</style>
